import React from 'react';
import styled from 'styled-components';

// Components
import {
  Button,
  BinderContent,
  DocumentActionsSnackbar,
  ToolButton
} from '@ibinder/common-frontend';

export const FormContainer = styled.form`
  height: 100%;
  display: flex;
  padding: 1rem;
  flex-direction: column;
  max-width: 700px;
  margin: 0 auto;
`;

export const StyledButton = styled(Button)`
  width: 25%;
  min-width: 100px;
  align-self: center;
`;

export const Icon = styled.div`
  width: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledDocumentActionsSnackbar = styled(DocumentActionsSnackbar)`
  bottom: 127.5px;
  height: auto;
  padding: 1em 0;
  max-width: 90%;
  right: 1rem !important;
`;

export const StyledToolButton = styled(ToolButton)`
  display: flex;
  height: 100%;

  span {
    height: 100%;
    margin: 0 !important;
  }
`;
